import script from "./PortfolioDayTradeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioDayTradeModal.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioDayTradeModal.vue?vue&type=style&index=0&id=d92db5c4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d92db5c4"]])

export default __exports__